import { Variants, motion } from "framer-motion";
import TimeLineTree from './TimeLineTree';



type Props = {}

const cardVariants: Variants = {
    offscreen: {
        fontSize: '0rem',
        y: 0,
    },
    onscreen: {
        fontSize: window.innerWidth > 768 ? '3rem' : '2rem',
        y: -100,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 20,
        },
    },
};

const row1Variants: Variants = {
    offscreen: {
        opacity: 0,
        y: 60,
    },
    onscreen: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 50,
            damping: 20,
        },
    },
};

export default function TimeLine({ }: Props) {
    return (
        <div
            style={{
                color: 'white',
                width: '100vw',
                marginTop: '30vh',
            }}
        >
            {/* title */}
            <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.8 }}
            >
                <motion.div
                    variants={cardVariants}
                    style={{
                        fontFamily: 'conthrax',
                        textAlign: 'center',
                    }}>
                    <div>LỊCH TRÌNH CUỘC THI</div>
                </motion.div>
            </motion.div>
            <div style={{
                fontFamily: 'Readex Pro',
                textAlign: 'center',
                width: window.innerWidth > 768 ? '60vw' : '80vw',
                margin: 'auto',
                fontSize: '.9rem',
                fontWeight: 300,
            }}>
                <motion.div
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: false, amount: 0.2 }}
                >
                    <motion.div
                        variants={row1Variants}
                    >
                        <TimeLineTree />
                    </motion.div>
                </motion.div>
            </div>
        </div>
    )
}
